"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yourContactInformationHeading = exports.userNotLoggedInErrorMessage = exports.socialAccountsHeadingText = exports.sharedItemsHeadingText = exports.scanQrToConnectText = exports.resumeHeadingText = exports.otherPreferencesHeadingText = exports.logInToChatWithMeButtonText = exports.logInAddMeToYourFriendsButtonText = exports.loadingMessage = exports.internalErrorMessage = exports.friendsHeadingText = exports.friendWasAddedSuccesMessage = exports.friendExistsMessage = exports.friendExistsAlreadyButtonText = exports.contactHeadingText = exports.communitiesHeadingText = exports.chatWithMeButtonText = exports.addMeToYourFriendsButtonText = void 0;
// QR CODE
const scanQrToConnectText = exports.scanQrToConnectText = 'Scan the QR code to connect with me';
//ERRORS & SUCCESS
//Same 'not logged in' error message like on 'Chat with me' button
const userNotLoggedInErrorMessage = exports.userNotLoggedInErrorMessage = 'Current user not found! Not logged in?';
const internalErrorMessage = exports.internalErrorMessage = 'An internal error occured!';
const friendWasAddedSuccesMessage = exports.friendWasAddedSuccesMessage = 'Friend was added!';

//OTHER
const friendExistsMessage = exports.friendExistsMessage = 'Friend already exists';
const loadingMessage = exports.loadingMessage = 'Loading...';

//BUTTONS
const addMeToYourFriendsButtonText = exports.addMeToYourFriendsButtonText = 'Add me to your friends';
const logInAddMeToYourFriendsButtonText = exports.logInAddMeToYourFriendsButtonText = 'Login to add me to your friends';
const logInToChatWithMeButtonText = exports.logInToChatWithMeButtonText = 'Login to chat with me';
const friendExistsAlreadyButtonText = exports.friendExistsAlreadyButtonText = 'Already part of friends';
const chatWithMeButtonText = exports.chatWithMeButtonText = 'Chat with me';

// Profile & Edit profile texts 
const yourContactInformationHeading = exports.yourContactInformationHeading = 'Contact Information';
const otherPreferencesHeadingText = exports.otherPreferencesHeadingText = 'Other Preferences';
const communitiesHeadingText = exports.communitiesHeadingText = 'Communities You Participate In';
const resumeHeadingText = exports.resumeHeadingText = 'Resume';
const socialAccountsHeadingText = exports.socialAccountsHeadingText = 'Social Accounts';
const sharedItemsHeadingText = exports.sharedItemsHeadingText = 'Shared Items';
const friendsHeadingText = exports.friendsHeadingText = 'Friends';
const contactHeadingText = exports.contactHeadingText = 'Contact';